export default {
    INIT:'INIT',

    MAIL_SEND_START: 'MAIL_SEND_START',
    MAIL_SEND_SUCCESS: 'MAIL_SEND_SUCCESS',
    MAIL_SEND_ERROR: 'MAIL_SEND_ERROR',

    RECORD_KEY_COPY_TO_CLIPBOARD_SUCCESS: 'RECORD_KEY_COPY_TO_CLIPBOARD_SUCCESS',

    RECORDS_FETCHING_START: 'RECORDS_FETCHING_START',
    RECORDS_FETCHING_ERROR: 'RECORDS_FETCHING_ERROR',
    RECORDS_FETCHING_SUCCESS: 'RECORDS_FETCHING_SUCCESS',
    RECORDS_FETCHING_NO_RESULT: 'RECORDS_FETCHING_NO_RESULT',

    RECORD_ADD_MODAL_OPEN: 'RECORD_ADD_MODAL_OPEN',
    RECORD_ADD_MODAL_CLOSE: 'RECORD_ADD_MODAL_CLOSE',
    RECORD_ADD_MODAL_CHANGE: 'RECORD_ADD_MODAL_CHANGE',

    RECORD_ADD_FORM_SUBMIT_START: 'RECORD_ADD_FORM_SUBMIT_START',
    RECORD_ADD_FORM_SUBMIT_SUCCESS: 'RECORD_ADD_FORM_SUBMIT_SUCCESS',
    RECORD_ADD_FORM_SUBMIT_ERROR: 'RECORD_ADD_FORM_SUBMIT_ERROR',
    RECORD_ADD_FORM_CHANGE: 'RECORD_ADD_FORM_CHANGE',
    RECORD_ADD_FORM_RESET: 'RECORD_ADD_FORM_RESET',

    RECORD_EDIT_MODAL_OPEN: 'RECORD_EDIT_MODAL_OPEN',
    RECORD_EDIT_MODAL_CLOSE: 'RECORD_EDIT_MODAL_CLOSE',
    RECORD_EDIT_MODAL_CHANGE: 'RECORD_EDIT_MODAL_CHANGE',


    RECORD_EDIT_FORM_SUBMIT_START: 'RECORD_EDIT_FORM_SUBMIT_START',
    RECORD_EDIT_FORM_SUBMIT_SUCCESS: 'RECORD_EDIT_FORM_SUBMIT_SUCCESS',
    RECORD_EDIT_FORM_SUBMIT_ERROR: 'RECORD_EDIT_FORM_SUBMIT_ERROR',
    RECORD_EDIT_FORM_CHANGE: 'RECORD_EDIT_FORM_CHANGE',
    RECORD_EDIT_FORM_RESET: 'RECORD_EDIT_FORM_RESET',

    RECORD_DELETE_FORM_SUBMIT_ERROR: 'RECORD_DELETE_FORM_SUBMIT_ERROR',
    RECORD_DELETE_FORM_SUBMIT_START: 'RECORD_DELETE_FORM_SUBMIT_START',
    RECORD_DELETE_FORM_SUBMIT_SUCCESS: 'RECORD_DELETE_FORM_SUBMIT_SUCCESS',


    RECORD_SEARCH_FORM_CHANGE: 'RECORD_SEARCH_FORM_CHANGE',
    RECORD_SEARCH_FORM_RESET: 'RECORD_SEARCH_FORM_RESET',

    AUTH_FORM_SUBMIT_START: 'AUTH_FORM_SUBMIT_START',
    AUTH_FORM_SUBMIT_SUCCESS: 'AUTH_FORM_SUBMIT_SUCCESS',
    AUTH_FORM_SUBMIT_ERROR: 'AUTH_FORM_SUBMIT_ERROR',
    AUTH_FORM_CHANGE: 'AUTH_FORM_CHANGE',

    AUTH_CHECK_START: 'AUTH_CHECK_START',
    AUTH_CHECK_ERROR: 'AUTH_CHECK_ERROR',
    AUTH_CHECK_SUCCESS: 'AUTH_CHECK_SUCCESS',

    LOGIN_ERROR: 'LOGIN_ERROR',
    LOGIN_SUCCESS: 'LOGIN_SUCCESS',
    LOGIN_START: 'LOGIN_START',

    LOGOUT_SUCCESS: 'LOGOUT_SUCCESS',
 
    NOTICE_ADD: 'NOTICE_ADD',
    NOTICE_CLEAR: 'NOTICE_CLEAR',

    NOTICE_MODAL_OPEN: 'NOTICE_MODAL_OPEN',
    NOTICE_MODAL_CLOSE: 'NOTICE_MODAL_CLOSE',
}


// WEBPACK FOOTER //
// ./src/constants/actionTypes.js